import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 200;
export function ScarcityBar() {
  const [taken, setTaken] = useState(183);
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const raf = window.setTimeout(() => setWidth(1), 200);
    return () => window.clearTimeout(raf);
  }, []);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setTaken(prev => prev < 191 ? prev + 1 : prev);
    }, 26000);
    return () => window.clearInterval(interval);
  }, []);
  const remaining = TOTAL_SPOTS - taken;
  const percent = Math.round(taken / TOTAL_SPOTS * 100);
  return <div className="w-full max-w-md rounded-2xl border border-gold-500/30 bg-navy-950/40 p-3.5" data-id="element-190" data-mp="227wjyy9ipocj">
      <div className="flex items-center justify-between gap-2" data-id="element-191" data-mp="275eyd46b0vrx">
        <p className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.1em] text-gold-400 sm:text-xs" data-id="element-192" data-mp="efd3wt7oriu">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-193" data-mp="5d9y95enis64" />
          Cupos al precio promocional
        </p>
        <p className="text-[11px] font-bold text-white sm:text-xs" data-id="element-194" data-mp="33l229a3ml10d">{percent}%</p>
      </div>
      <div className="mt-2 h-3 w-full overflow-hidden rounded-full bg-white/15" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent} aria-label="Cupos ocupados al precio promocional" data-id="element-195" data-mp="2zl19sljoypab">
        <div className="h-full rounded-full bg-gold-500 transition-[width] duration-[1400ms] ease-out" style={{
        width: width ? `${percent}%` : '0%'
      }} data-id="element-196" data-mp="2kn8zc7t04r2z" />
      </div>
      <p className="mt-2 text-[12px] font-semibold leading-snug text-cream-100 sm:text-[13px]" data-id="element-197" data-mp="2umgk3g22fo04">
        Solo quedan{' '}
        <span className="rounded-md bg-gold-500 px-1.5 py-0.5 font-extrabold text-navy-950" data-id="element-198" data-mp="2pmc3lq15qt9w">
          {remaining} cupos
        </span>{' '}
        con el precio de USD 15. Al agotarse, vuelve a USD 197.
      </p>
    </div>;
}